import {Clone, GetEntries, GetErrorMessagesUnderElement, CloneWithPrototypes, E} from "js-vextensions";
import Moment from "moment";
import {Column, Pre, RowLR, Select, Spinner, TextInput, Text, Row, Button} from "react-vcomponents";
import {BaseComponent, BaseComponentWithConnector, BaseComponentPlus} from "react-vextensions";
import {Sound, SoundType} from "../../../Server/DB/sounds/@Sound.js";
import {InfoButton, YoutubeSpeed, YoutubeQuality, GetVoices, Observer, observer_simple} from "web-vcore";
import {name_general} from "../../../Utils/General/SharedPatterns.js";
import {User} from "../../../Server/DB/users/@User.js";
import {GenericEntryInfoUI} from "../../@Shared/CommonPropUIs/GenericEntryInfoUI.js";
import {BoxController, ShowMessageBox} from "react-vmessagebox";
import {AddSound} from "../../../Server/Commands/SoundCommands.js";
import {AddScene} from "../../../Server/Commands/SceneCommands.js";
import {Scene} from "../../../Server/DB/scenes/@Scene.js";
import {TagsInput} from "../../../Utils/ReactComponents/TagsInput.js";
import {GetUser} from "../../../Server/DB/users.js";
import React, {useState} from "react";
import {PreviewImageSquare} from "../../@Shared/PreviewImageSquare.js";
import {DialogStyle} from "../../../Utils/UI/GlobalStyles.js";
import {DetailsUI_Base_Props, useDetailsUICore} from "../../@Shared/DetailsUI_Base.js";
import {observer_mgl} from "mobx-graphlink";

export function ShowAddSceneDialog(initialData?: Partial<Scene>, postAdd?: (id: string)=>any) {
	let newEntry = new Scene(E({
		name: "",
	}, initialData));
	const getCommand = ()=>new AddScene({entry: newEntry});

	const boxController: BoxController = ShowMessageBox({
		title: "Add scene", cancelButton: true,
		message: observer_simple(()=>{
			const tempCommand = getCommand();
			boxController.UpdateOptions({okButtonProps: {
				enabled: tempCommand.Validate_Safe() == null,
				title: tempCommand.validateError,
			}});

			return (
				<Column style={DialogStyle({width: 600})}>
					<SceneDetailsUI baseData={newEntry} phase="create"
						onChange={(val, error)=>{
							newEntry = val;
							boxController.UpdateUI();
						}}/>
				</Column>
			);
		}),
		onOK: async()=>{
			const {id} = await getCommand().RunOnServer();
			if (postAdd) postAdd(id);
		},
	});
}

const splitAt = 150, width = "100%";

export const SceneDetailsUI = observer_mgl((props: DetailsUI_Base_Props<Scene>)=>{
	const {phase, style} = props;
	const {rootRef, newData, helpers} = useDetailsUICore(props);
	const {Change, creating, enabled} = helpers;
	//const nodeAccessPolicy = GetAccessPolicy(newData.nodeAccessPolicy);
	const creator = phase != "create" && GetUser(newData.creator);

	const [previewing, setPreviewing] = useState(false);

	//const propsEnhanced = {...this.props, newData, Change};
	return (
		<Column ref={rootRef} style={style}>
			{phase != "create" &&
				<GenericEntryInfoUI id={newData.id} creatorID={newData.creator} createdAt={newData.createdAt}/>}
			<RowLR mt={5} splitAt={splitAt} style={{width}}>
				<Text>Name:</Text>
				<TextInput pattern={name_general} required
					enabled={enabled} style={{width: "100%"}}
					value={newData.name} onChange={val=>Change(newData.name = val)}/>
			</RowLR>
			<RowLR mt={5} splitAt={splitAt} style={{width}}>
				<Text>URL:</Text>
				<TextInput required
					enabled={enabled} style={{width: "100%"}}
					value={newData.url} onChange={val=>Change(newData.url = val)}/>
			</RowLR>
			<RowLR mt={5} splitAt={splitAt} style={{width}}>
				<Text>Suggested tags:</Text>
				<TagsInput enabled={enabled} style={{width: "100%"}} value={newData.tags} onChange={val=>Change(newData.tags = val)}/>
			</RowLR>
			<RowLR mt={5} splitAt={splitAt}>
				<Text>Preview square:</Text>
				<Text>Center (x, y):</Text>
				<Spinner ml={5} enabled={enabled} min={0} max={100}
					value={(newData.square_center.x * 100).RoundTo(1)} onChange={val=>Change(newData.square_center.x = val / 100)}/>
				<Spinner enabled={enabled} min={0} max={100}
					value={(newData.square_center.y * 100).RoundTo(1)} onChange={val=>Change(newData.square_center.y = val / 100)}/>
				<Text ml={5}>Size:</Text>
				<Spinner ml={5} enabled={enabled} min={1} max={100}
					value={(newData.square_size * 100).RoundTo(1)} onChange={val=>Change(newData.square_size = val / 100)}/>
			</RowLR>
			<RowLR mt={5} splitAt={splitAt}>
				<Text>Ground-edge (x, y):</Text>
				<Text>Left/top:</Text>
				<Spinner ml={5} enabled={enabled} min={0} max={100}
					value={(newData.groundEdge_left.x * 100).RoundTo(1)} onChange={val=>Change(newData.groundEdge_left.x = val / 100)}/>
				<Spinner enabled={enabled} min={0} max={100}
					value={(newData.groundEdge_left.y * 100).RoundTo(1)} onChange={val=>Change(newData.groundEdge_left.y = val / 100)}/>
				<Text ml={5}>Right/bottom:</Text>
				<Spinner ml={5} enabled={enabled} min={0} max={100}
					value={(newData.groundEdge_right.x * 100).RoundTo(1)} onChange={val=>Change(newData.groundEdge_right.x = val / 100)}/>
				<Spinner enabled={enabled} min={0} max={100}
					value={(newData.groundEdge_right.y * 100).RoundTo(1)} onChange={val=>Change(newData.groundEdge_right.y = val / 100)}/>
			</RowLR>
			<RowLR mt={5} splitAt={splitAt}>
				<Text>Door:</Text>
				<Text>Base-pos:</Text>
				<Spinner ml={5} enabled={enabled} min={0} max={100}
					value={(newData.door_basePos.x * 100).RoundTo(1)} onChange={val=>Change(newData.door_basePos.x = val / 100)}/>
				<Spinner enabled={enabled} min={0} max={100}
					value={(newData.door_basePos.y * 100).RoundTo(1)} onChange={val=>Change(newData.door_basePos.y = val / 100)}/>
				<Text ml={5}>Height:</Text>
				<Spinner ml={5} enabled={enabled} min={1} max={100}
					value={(newData.door_height * 100).RoundTo(1)} onChange={val=>Change(newData.door_height = val / 100)}/>
			</RowLR>
			<Button text={previewing ? "Hide preview" : "Preview scene"} mt={5} width={200} onClick={()=>{
				setPreviewing(!previewing);
			}}/>
			{previewing &&
			<div style={{position: "relative"}}>
				<PreviewImageSquare entry={newData} style={{width: "100%", paddingBottom: "100%"}}/>
			</div>}
		</Column>
	);
});